import { CustomExportFileModel } from "./customExportFile.model";
export class ShipmentQrConfirmFilter{
    fromDate:any;
    toDate:any;
    pageNumber:number =1;
    pageSize:number = 20;
    customExportFile: CustomExportFileModel = new CustomExportFileModel();
}